'use strict';

angular.module('userRequestProcessControllers')

    .controller('ProcessRequestController', ['$scope', '$rootScope', '$state', '$translate', 'authenticatedUser', 'custodians', 'infosToProcessRequest', 'newIamUrl', 'userAccessRequestService', 'processAccessRequestService', function ($scope, $rootScope, $state, $translate, authenticatedUser, custodians, infosToProcessRequest, newIamUrl, userAccessRequestService, processAccessRequestService) {

        $scope.newIamUrl = newIamUrl;

        $scope.nbCardsByGroup = 3;

        // Manage custodian
        $scope.custodians = custodians;

        $scope.getCustodianLabel = function (custodianId) {
            return $scope.custodians[custodianId];
        }

        // Manage chatting
        $scope.chatting = {};
        $scope.chatting.isExpandedBox = false;

        $scope.chatting.toggleExpandedBox = function () {
            $scope.chatting.isExpandedBox = !$scope.chatting.isExpandedBox;

            $scope.groupsOfCards = processAccessRequestService.getGroupsOfCards($scope.cards, $scope.nbCardsByGroup);
        }

        // Manage Cards
        $scope.authenticatedUser = authenticatedUser;

        $scope.infosToProcess = infosToProcessRequest;
        $scope.cards = infosToProcessRequest.Cards;
        $scope.userCustodianName = infosToProcessRequest.CustodianName;
        $scope.groupsOfCards = processAccessRequestService.getGroupsOfCards($scope.cards, $scope.nbCardsByGroup);
        $scope.userAccessRequest = infosToProcessRequest.UserAccessRequest;
        $scope.employeeId=$scope.userAccessRequest?.Employee?.EmployeeID;
        $scope.supervisorId = $scope.userAccessRequest?.ActualSupervisorID;
        $scope.supervisorDelegateId = $scope.userAccessRequest?.ApprovedBySupervisorID !== $scope.userAccessRequest?.ActualSupervisorID ? $scope.userAccessRequest?.ApprovedBySupervisorID : null;

        $scope.isRequestCancellable = function () {
            if (!$scope.authenticatedUser.IsInAdministrationGroup && !$scope.authenticatedUser.IsInBTGAccessManagementGroup) return false;

            if ($scope.userAccessRequest.IsEditable) return true;
            return !$scope.userAccessRequest.IsCompleted;
        }

        $scope.cancelRequest = function () {
            $scope.actionSubmit = processAccessRequestService.cancel($scope.userAccessRequest.UserAccessRequestID);
            $scope.actionSubmit.then(function (response) {
                if (response.statusText === 'OK') {
                    $state.go('userAccessRequest', {},
                        { reload: true });
                }
            });
        }

        $scope.userAccessRequest.StateProcessing = null;
        $scope.$watch('userAccessRequest.AdminTicketNumber', function (newVal, oldVal) {
            if (newVal !== oldVal) {
                $scope.userAccessRequest.StateProcessing = 'Saving';

                processAccessRequestService.updateAdminTicketNumber($scope.userAccessRequest.UserAccessRequestID, $scope.userAccessRequest.AdminTicketNumber)
                    .then(function (updatedRequest) {
                        $scope.userAccessRequest.SdeLink = updatedRequest.SdeLink;
                        $scope.userAccessRequest.StateProcessing = 'Saved';
                    });
            }
        });

        $scope.IsVisibleAdminTicketNumber = function () {
            return ($scope.userCustodianName == 'BTG Access Management' || _.includes($scope.authenticatedUser.UserADGroups, 'id-admin'));
        }

        $scope.confCards = {
            ItPurchasingInstructionsCard: {
                template: '/app/Main/userRequest/userRequestProcess/CardITPurchasingInstructions.tpl.html',
                controller: 'CardITPurchasingInstructionsController'
            },
            SystemRolePendingCard: {
                template: '/app/Main/userRequest/userRequestProcess/CardSystemRolePending.tpl.html',
                controller: 'CardSystemRolePendingController'
            }
        };

        $scope.getTemplateAndControllerCard = function (card) {
            return $scope.confCards[card.CardClass];
        }

        $scope.$on('cardIsProcessed', function () {
            var allIsProcessed = false;
            var cardsNotProcessed = _.filter($scope.cards, function (card) {
                return !_.isUndefined(card.IsProcessed) && card.IsProcessed === false;
            });

            if (cardsNotProcessed.length === 0) {
                userAccessRequestService.getRequest($scope.userAccessRequest.UserAccessRequestID)
                    .then(function (updatedRequest) {

                        $scope.userAccessRequest.RequestStatusCssClass = updatedRequest.RequestStatusCssClass;
                        $scope.userAccessRequest.BoxRequestStatusCssClass = updatedRequest.BoxRequestStatusCssClass;
                        $scope.userAccessRequest.RequestStatus = updatedRequest.RequestStatus;
                        $scope.userAccessRequest.RequestStatusLabel = updatedRequest.RequestStatusLabel;
                        $scope.userAccessRequest.UpdatedTimestamp = updatedRequest.UpdatedTimestamp;

                        $rootScope.$broadcast('requestIsProcessed', {
                            UserAccessRequest: updatedRequest
                        });
                    });
            }
        });
    }]);
